import PropTypes from 'prop-types';
import React from 'react';
import { Trans, useTranslation } from 'react-i18next';

import ModalButton, { ModalButtonDivider } from 'components/modals/modal_button';
import ModalFooter from 'components/modals/modal_footer';
import InternalEmailIcon from './internal_email_icon';
import Modal from 'components/lib/modal';
import PortalModalWrapper from 'components/lib/portal_modal_wrapper';

function InternalEmailModal(props) {
  const { t } = useTranslation();
  return (
    <PortalModalWrapper>
      <Modal className="internalEmailModal">
        <div className="internalEmailModal-iconContainer">
          <InternalEmailIcon />
        </div>
        <div className="internalEmailModal-header">{t('Private Conversations')}</div>
        <div className="internalEmailModal-body">
          <Trans
            components={{ member: <strong /> }}
            defaults="You may be including private conversations about <member>{{memberDescription}}</member> in this message"
            values={{ memberDescription: props.memberDescription }}
          />
        </div>
        <ModalFooter data-aid="internalEmailModal-footer">
          <ModalButton className="internalEmailModal-keepButton" onClick={props.onKeepHistory}>
            {t('Keep Original Message')}
          </ModalButton>
          <ModalButtonDivider />
          <ModalButton className="internalEmailModal-removeButton" onClick={props.onRemoveHistory}>
            {t('Remove Original Message')}
          </ModalButton>
        </ModalFooter>
      </Modal>
    </PortalModalWrapper>
  );
}

InternalEmailModal.propTypes = {
  memberDescription: PropTypes.string.isRequired,
  onKeepHistory: PropTypes.func.isRequired,
  onRemoveHistory: PropTypes.func.isRequired,
};

export default InternalEmailModal;
